module.exports = __webpack_public_path__ + "img/srten.d432f71a.png";